import { EditionId } from "@carnegie-learning/common-types";
import { Edition } from "@carnegie-learning/cure-types";
import { Action, createReducer, on } from "@ngrx/store";
import * as editionActions from "../actions/active-editions.action";

export interface ActiveEditionsState {
    entities: Map<string, Edition>;
    loading: boolean;
    loaded: boolean;
}

export const initialState: ActiveEditionsState = {
    entities: new Map<string, Edition>(),
    loading: false,
    loaded: false,
};

const subjectReducer = createReducer(
    initialState,
    on(editionActions.LoadActiveEditions, (state) => {
        return {
            ...state,
            loading: true,
            loaded: false,
        };
    }),
    on(editionActions.LoadActiveEditionsFail, (state) => {
        return {
            ...state,
            loading: false,
            loaded: false,
        };
    }),
    on(editionActions.LoadActiveEditionsSuccess, (state, { payload }) => {
        const activeEditions = payload.data;
        const entities = new Map<EditionId, Edition>();
        activeEditions.forEach((activeEdition) => {
            const id = activeEdition.editionId;
            entities.set(id, activeEdition);
        });
        return {
            ...state,
            loading: false,
            loaded: true,
            entities,
        };
    })
);

export function reducer(
    state: ActiveEditionsState | undefined,
    action: Action
) {
    return subjectReducer(state, action);
}

export const getActiveEditionsEntities = (state: ActiveEditionsState) =>
    state.entities;
export const getActiveEditionsLoading = (state: ActiveEditionsState) =>
    state.loading;
export const getActiveEditionsLoaded = (state: ActiveEditionsState) =>
    state.loaded;
